// Jede comdirect-Synchronisierung aktualisiert serverseitig immer Depot UND
// Orderbuch zusammen (BrokerageTask::syncBrokerageData()) - unabhaengig
// davon, von welcher Seite aus sie ausgeloest wurde. Die jeweils andere Seite
// bleibt aber (wie ueblich in dieser App, siehe Module.js) im Hintergrund
// gemountet und laedt ihre eigenen Daten nicht automatisch neu, sobald
// woanders synchronisiert wurde (Chat vom 2026-07-26, Bugreport: neu
// ausgefuehrte Order im Orderbuch sichtbar, aber die zugehoerige Position
// fehlte in der Depotuebersicht, bis dort separat auf Reload geklickt wurde).
//
// Einfache globale Listener-Liste auf x.was (wie x.was.brokerageSession
// etc.) - jede Depotuebersicht-/Orderbuch-Instanz traegt sich beim Mounten
// ein und laedt bei Benachrichtigung ihre eigenen Daten neu.
export function registerBrokerageDataListener(x, listener) {
	if (!x.was.brokerageDataListeners) {
		x.was.brokerageDataListeners = [];
	}
	x.was.brokerageDataListeners.push(listener);
	return () => {
		x.was.brokerageDataListeners = (x.was.brokerageDataListeners || []).filter((entry) => entry !== listener);
	};
}

export function notifyBrokerageDataChanged(x) {
	(x.was.brokerageDataListeners || []).forEach((listener) => listener());
}
